import {collection, getDocs} from 'firebase/firestore';
import {firestore} from '../firebase';
import {FirestoreCollection, InterestCategory} from 'hubbl-shared';

const getInterestCategories = async (): Promise<InterestCategory[]> => {
  const colRef = collection(firestore, FirestoreCollection.Interests);
  const snapshot = await getDocs(colRef);
  return snapshot.docs
    .map(doc => doc.data() as InterestCategory)
    .sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
};

export const interests = {
  getInterestCategories,
};
